module.exports = __webpack_public_path__ + "static/img/yapeiAL1.1a874ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/yapeiAL1.jpg
// module id = /Kuk
// module chunks = 0